"use client"

import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

function Progress({
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        // §02.5 measures: "Progress · 4 track · full-bleed within its
        // container" — a flat rule, not a pill. It's read, not pressed.
        "relative h-1 w-full overflow-hidden rounded-[var(--ls-radius-0)] bg-[var(--tls-surface-hover)]",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="size-full flex-1 bg-[var(--tls-brand)] transition-transform duration-[var(--motion-duration-fast)] ease-linear"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  )
}

export { Progress }
